module.exports = __webpack_public_path__ + "assets/images/USDNEW100.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/USDNEW100.png
// module id = 1460
// module chunks = 1